export default {
  list: { lazy: () => import('./CustomFormList') },
  edit: { lazy: () => import('./CustomFormEdit') },
  create: { lazy: () => import('./CustomFormCreate') },
  options: {
    list: {
      title: 'Custom Forms',
      breadCrumb: 'Custom Forms',
    },
    show: {
      title: 'Custom Form title',
      subtitle: null,
      breadCrumb: 'Custom Form',
    },
  },
}
